import axios, { Axios, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
const axiosStatic = axios;
// 请求列表 存储请求标识和取消函数
const pending = new Map();


function getUrlSign(config: InternalAxiosRequestConfig): string {
    let params = '';
    if (config?.params) {
        params = typeof config.params === typeof '' ? config.params : JSON.stringify(config.params);
    }
    let data = '';
    if (config?.data) {
        data = typeof config.data === typeof '' ? config.data : JSON.stringify(config.data);
    }
    const sign = [config.method, config.url, params, data].join('&');
    return sign;
}

/**
 * 添加请求
 * @param {Object} config
 */
const addPending = (config: InternalAxiosRequestConfig): void => {
    // 请求url 标识
    const url = getUrlSign(config);
    config.cancelToken = config.cancelToken || new axios.CancelToken(cancel => {
        // 没有添加过该请求，就加入
        if (!pending.has(url)) {
            pending.set(url, cancel);
        }
    });
};

/**
 * 移除请求
 * @param {Object} config
 */
const removePending = (config: InternalAxiosRequestConfig): void => {
    // 请求url 标识
    const url = getUrlSign(config);
    if (pending.has(url)) {
        // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
        const cancel = pending.get(url);
        cancel();
        pending.delete(url);
    }
};



let action =  (axios: Axios): void => {
    axios.interceptors.request.use(
        (config: InternalAxiosRequestConfig) => {
            removePending(config);
            addPending(config);
            return config;
        },
        (err: any) => {
            removePending(err.config);
            return Promise.reject(err);
        }
    );
    axios.interceptors.response.use(
        (res: AxiosResponse) => {
            removePending(res.config);
            return res;
        },
        (err: any) => {
            if (!axiosStatic.isAxiosError(err)) {
                err.config && removePending(err.config as InternalAxiosRequestConfig);
            }
            return Promise.reject(err);
        }
    );
};

export default action